/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    query BlockIpReadQuery($blockIpDisplayNameToSearch: String, $take: PositiveInt, $skip: Int) {
      BlockIpRead(blockIpDisplayNameToSearch: $blockIpDisplayNameToSearch, take: $take, skip: $skip) {
        id,
        createdAt,
        updatedAt,
        displayName,
        status,
        message,
        _totalCount
    }
  }
`
